import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../core/services/common.service';
import { SharedModal } from '../../../../shared/components/shared-modal/shared-modal';
import { Loader } from '../../../../shared/components/loader/loader';
import { CustomPaginationComponent } from '../../../../shared/components/custom-pagination/custom-pagination.component';
import { FilterSharedDropdown } from '../../../../shared/components/filter-shared-dropdown/filter-shared-dropdown';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import user_endpoint from '../../../data/api-endpoint/user-endpoint';
import { CreateUser } from '../create-user/create-user';
import { Subscription } from 'rxjs';
import { UpperCasePipe } from '../../../../shared/pipes/upper-case-pipe';

@Component({
  selector: 'app-user-listing',
  standalone: true,
  imports: [CommonModule, Loader, CustomPaginationComponent, FilterSharedDropdown,
    FormsModule, SharedModal, NoDataComponent, CreateUser,UpperCasePipe],
  templateUrl: './user-listing.html',
  styleUrl: './user-listing.scss'
})
export class UserListing {
  sortingKey: string = '';
  sortingValue: string = '';
  searchIcon = 'assets/img/search.svg';
  filterIcon = 'assets/img/filter.png';
  plusIcon = 'assets/img/plus.svg';
  editIcon = 'assets/img/edit.png';
  deleteIcon = 'assets/img/bin.png';
  upIcon = 'assets/img/up.png';
  downIcon = 'assets/img/down.png';
  poolId!: string


  currentItem: any = null;

  debounceTimeout: any
  userId!: string;

  loading: boolean = false;
  isActiveFilter: boolean = false;
  toggleFilter: boolean = false;
  noData: boolean = false;
  totalCount: number = 0;


  filter: any = {
    page: 1,
    limit: 10,
    search: '',
    name: [],
    role: [],
    sortKey: '',
    sortValue: ''
  }

  modalConfig: { isOpen: boolean, type: 'user-delete' | 'user-deactivate' | 'user-activate', contentName?: string } = {
    isOpen: false,
    type: 'user-delete'
  };


  



  roleList: any = [{name:'Admin',value:'admin'},{name:'User',value:'user'}];
  nameList: any = [];

  userList: any[] = []
  userPermissions: any[] = [];
  userSubscription: Subscription = new Subscription();

  constructor( private _commonService: CommonService,
    private _contentMapper: ContentMapperService, private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this.fetchNameList()
    this.fetchUserList('ngOnInit');
    this.userSubscription = this._commonService.getUserDetail().subscribe((user: any) => {
      this.userPermissions = user.permissions_ids;
    })
  
  }




  openFilter() {
    this.toggleFilter = !this.toggleFilter;
  }

  reloadUserList(): void {
    this._commonService.updateUserModal({ isOpen: false, type: 'Create User' });
    this.clearFilter()
  }

  sorting(key: string) {
    this.sortingKey = key;
    this.sortingValue = !this.sortingValue ? 'ASC' : (this.sortingValue === 'ASC' ? 'DESC' : 'ASC');
    this.filter.sortKey = this.sortingKey;
    this.filter.sortValue = this.sortingValue;
    this.filter.page = 1;
    this.fetchUserList()
  }

 


  clearFilter() {
    this.filter = {
      page: 1,
      limit: 10,
      search: '',
      name: [],
      role: [],
      sortKey: '',
      sortValue: ''
    };
    this.sortingKey = ''
    this.sortingValue = ''
    this.fetchUserList()

  }

  onSearch(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.filter.search = value?.trim();
      this.filter.page = 1;
      this.fetchUserList()
    }, 1000);
  }



  clearFilterDropdown(type: string) {
    const action: Record<string, () => void> = {
      'name': () => this.filter.name = [],
      'role': () => this.filter.role = [],
    };
    action[type]()
    this.filter.page = 1;
    this.fetchUserList();

  }


  selectFilterDrowDownItem(data: { checked: boolean }, type: string) {
    const { checked } = data;
    const action: Record<string, () => void> = {
      'name': () => this.filter = {
        ...this.filter,
        name: checked ? this.nameList : []
      },
      'role': () => this.filter = {
        ...this.filter,
        role: checked ? structuredClone(this.roleList) : []
      },
    };
    action[type]();
    this.filter.page = 1;
    this.fetchUserList();
  }

  isItemChecked(data: { checked: boolean, item: any }, type: string) {
    const { checked, item } = data;
    const action: Record<string, () => void> = {
      'name': () => checked ? this.filter.name.push(item) : this.filter.name = this.filter.name.filter((child: any) => child.name != item.name),
      'role': () => checked ? this.filter.role.push(item) : this.filter.role = this.filter.role.filter((child: any) => child.name != item.name),
    };
    action[type]();
    this.filter.page = 1;
    this.fetchUserList();

  }

  fetchUserDataByPage(data: { page: number }) {
    this.filter.page = data.page;
    this.fetchUserList();
  }


  openDeleteModal(user: any): void {
    this.currentItem = user;
    this.modalConfig = {
      isOpen: true,
      type: 'user-delete',
      contentName: user.contentName
    };
  }

  openStatusChangeModal(user: any, isActivating: boolean): void {
    this.currentItem = user;
    this.modalConfig = {
      isOpen: true,
      type: isActivating ? 'user-activate' : 'user-deactivate',
      contentName: user.contentName
    };
  }

  onModalConfirm(): void {
    if (!this.currentItem) return;

    switch (this.modalConfig.type) {
      case 'user-delete':
        this.deleteUser(this.currentItem);
        break;
      case 'user-deactivate':
        this.changeUserStatus(this.currentItem, false);
        break;
      case 'user-activate':
        this.changeUserStatus(this.currentItem, true);
        break;
    }

    this.closeModal();
  }

  onModalCancel(): void {
    this.closeModal();
    if (this.userId) {
      const user = this.userList.find((user) => user.id == this.userId);
      if (user) {
        delete user.tempStatus;
        this.userId = '';
      }
    }
  }

  onToggleStatus(user: any, event: any): void {
    event.preventDefault();
    this.userId = user.id
    if (user.status == 'active') {
      user.tempStatus = false
      this.openStatusChangeModal(user, false);
    } else {
      user.tempStatus = true;
      this.openStatusChangeModal(user, true);
    }
  }

  private closeModal(): void {
    this.modalConfig.isOpen = false;
    this.currentItem = null;
  }

  openCreateUserModal(): void {
    this._commonService.updateUserModal({
      isOpen: true,
      type: 'Create User'
    });
  }

  openEditUserModal(id: number): void {
    this._commonService.updateUserModal({ isOpen: true, type: 'Edit User', userId: id });
  }
 

  closeUserModal(): void {
    this._commonService.updateUserModal({ isOpen: false, type: 'Create User' });
  }

  private buildQuery() {
    const params = new URLSearchParams()
    Object.entries(this.filter).forEach(([key, value]: [string, any]) => {
      switch (key) {
        case 'page':
          params.append(key, value)
          break;
        case 'search':
          if (value) {
            params.append(key, value);
          }
          break;
        case 'limit':
          params.append('limit', '10');
          break;
        case 'name':
          const id = value?.map((item: any) => item.value)?.join(',');
          if (id) {
            params.append(key, id);
          }
          break;
        case 'role':
          const role = value.map((item: any) => item.value)?.join(',');
          if (role) {
            params.append(key, role);
          }
          break;
        case 'sortKey':
          params.append(key, value);
          break;
        case 'sortValue':
          params.append(key, value);
          break;
        default:
          params.append(key, value);
          break;
      }
    });
    return params
  }

  private fetchNameList() {
    this._contentMapper.get(user_endpoint.nameList).subscribe({
      next: (response: any) => {
        this.nameList = response.results;
      }, error: (error) => {
        this.nameList = []
        console.error('Error occured while fetching name', error.message);
      }
    })
  }

  private deleteUser(user: any): void {
    this._contentMapper.delete(user_endpoint.user + `/${user.id}`).subscribe({
      next: (response: any) => {
        this.toastr.success(response.message);
        this.fetchUserList('ngOnInit');
      }, error: (error: any) => {
        if (error.error.status_code !== 401 && error.error.status_code !== 403) {
          this.toastr.error('Failed to delete user');
          console.log('Error occured while deleting user', error.message);
        }
      }
    })
  }

  private changeUserStatus(user: any, isActivating: boolean): void {
    this._contentMapper.put(user_endpoint.changeUserStatus, { id: user.id, status: isActivating ? 'active' : 'inactive' }).subscribe({
      next: (response: any) => {
        this.toastr.success(response.message);
        this.fetchUserList('ngOnInit');
      }, error: (error: any) => {
        if (error.error.status_code !== 401 && error.error.status_code !== 403) {
          this.toastr.error('Failed to change user status');
          console.log('Error occured while changing user status', error.message);
        }
      }
    });
  }


  private fetchUserList(source: string = 'unknown') {
    this.loading = true;
    const params = this.buildQuery();
    this._contentMapper.get(user_endpoint.user + '?' + params.toString()).subscribe({
      next: (response: any) => {
        this.totalCount = response?.results?.totalCount || 0;
        this._commonService.updateSharedData(this.totalCount);

        const userList = response?.results || {results: []};

        if(userList.results.length > 0) {
          this.userList = userList.results
        }

        this.noData = source === 'ngOnInit' && this.userList.length === 0 ? true : false;
        this.loading = false
      }, error: (error) => {
        this.loading = false
        if (error.error.status_code !== 401 && error.error.status_code !== 403) {
          this.toastr.error("An Unknown error occured");
          console.error("Error occured while fetching user list", error.message);
        }
      }
    })

  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }


}
